import React from 'react';
import PropTypes from 'prop-types';
import {scenariosData} from 'data/scenarios-data';
import './logo.scss';

const Logo = ({scenarioId}) => {
	const scenarioData = scenariosData[scenarioId];
	return (
		<div className="Logo">
			<span>{scenarioData.title}</span>
		</div>
	);
};


Logo.propTypes = {
	scenarioId: PropTypes.string
};

export default Logo;
